<template>
  <div>
    <div class="row text-white inner-row" :style="object.archivedDate ? 'background: #293b2e' : 'background: #2e714a'">
      <div class="col-md-8" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.basis.name}}</b>
      </div>
      <div class="col-md-4" style="text-align: right">
        <i v-if="!object.archivedDate" class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
        <b v-else-if="object.archivedDate">В АРХИВЕ</b>
      </div>
    </div>

    <div class="row inner-row" style="background: #f1f1f1">
      <div class="col-md-12">
        <div class="row" v-if="clientView === 'text'" v-on:click="clientView = 'full'">
          <div class="col-md-2">
            <i class="tim-icons icon-minimal-down"></i>
            Клиент
          </div>
          <div class="col-md-10">
            {{client.object.name}}
          </div>
        </div>

        <client-view v-if="clientView === 'full'" :item="client" :hide-t-s-rs="true"
                     @toRow="clientView = 'text'" @toEdit="clientView = 'edit'"
        ></client-view>

        <client-edit v-if="clientView === 'edit'" :item="client" :type="'client'"
                     @toView="clientView = 'full'"
        ></client-edit>
      </div>
    </div>

    <simple-row :name="'Наименование'" :value="object.basis.name"></simple-row>
    <simple-row :name="'Компенсация'" :value="object.compensation"></simple-row>
    <simple-row :name="'Стоимость'" :value="object.costPrice"></simple-row>
    <simple-row :name="'Дополнительная информация'" :value="object.note"></simple-row>
    <simple-row :name="'Следующая дата'" :value="convertDate(object.nextDate)"></simple-row>

    <br/>
    <tsr-kits v-if="showKits" :item="item.object" @hide="showKits = false" @update_top="refresh"></tsr-kits>
    <p v-else> Установки врамках ТСР <i v-on:click="showKits = true" class="tim-icons icon-minimal-down"></i></p>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";
 import {convertLongToPeriod} from "@/services/periods-service";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showKits: false,
       clientView: 'text',
       client: null
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     convertToPeriod(time) {
       return time ? convertLongToPeriod(time).name : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     async refresh() {
       this.item.object = await this.$repo.get(this.item.id, 'tsr');
       this.object = this.item.object;
     }
   },
   mounted() {
     this.client = {object: this.object.ipr.client, id: this.object.ipr.client.id}
   }
 }
</script>
<style>
</style>
